export default __webpack_public_path__ + "static/media/049-buret.03c2bef3.svg";